// extracted by mini-css-extract-plugin
export default {"status":"CheckCard_status__P6lA0","tooltip":"CheckCard_tooltip__D9lNv"};